<script setup lang="ts">
import type { ICookieConsent, ICookies } from '~/plugins/boot.client';

const { $cookies } = useNuxtApp();
const cookies = $cookies as ICookies;

const modal = computed<boolean>((): boolean => !(cookies?.consent?.value?.consent ?? false));

const optional = ref<boolean>();
const performance = ref<Number | number>(cookies?.consent?.value?.optional?.performance ? 1 : 0);
const advertisement = ref<Number | number>(cookies?.consent?.value?.optional?.advertisement ? 1 : 0);

const confirm = (performance: boolean | Number | number = true, advertisement: boolean | Number | number = true): void => {
  if (cookies?.consent?.value)
    cookies.consent.value = <ICookieConsent>{
      version: (useRuntimeConfig()?.public?.cookie?.version ?? '1.0'),
      consent: true,
      optional: {
        performance: ((performance == 1) ? true : false) as boolean,
        advertisement: ((advertisement == 1) ? true : false) as boolean
      }
    };
};
</script>

<template>
  <div>
    <BaseModal
      v-model="modal"
      :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
      :class-name="[
        ('bg-white text-center flex flex-col justify-center items-center gap-2 xl:gap-4 max-w-sm'),
        ('shadow-' + (['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg'))
      ]">
      <BaseText
        class="font-semibold"
        :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')">
        <h1>
          🍪 Používanie cookies 🍪
        </h1>
      </BaseText>
      <BaseText class="flex flex-col gap-2 xl:gap-4">
        Táto webová stránka používa cookies na zlepšenie vášho zážitku a analýzu návštevnosti. Pokračovaním v prehliadaní stránky súhlasíte s ich používaním. <br />
        Pre viac informácií nám napíšte email alebo nás telefonicky kontaktujte.
      </BaseText>
      <BaseCollapse
        v-model="optional"
        class="open:animate-[down-fade-in_400ms_ease-in]">
        <BaseBox
          rounded
          class="flex flex-col gap-1 xl:gap-2 border-2 text-left">
          <BaseBox class="grid gap-1 xl:gap-2">
            <BaseText>
              <h2 class="font-semibold">
                Nevyhnutné cookies
              </h2>
              <i>
                Tieto cookies sú potrebné pre správne fungovanie stránky a nemožno ich vypnúť v našich systémoch.
              </i>
            </BaseText>
            <BaseInput
              class="flex flex-row justify-between items-center gap-1 xl:gap-2"
              title="Funkčné cookie"
              type="checkbox"
              true-value="1"
              false-value="0"
              :value="1"
              disabled
              no-grid />
          </BaseBox>
          <BaseBox class="grid gap-1 xl:gap-2 border" block>
            <BaseText>
              <h2 class="font-semibold">
                Voliteľné cookies
              </h2>
              <i>
                Tieto cookies nám pomáhajú zlepšiť váš zážitok a prispôsobiť obsah vašim preferenciám.
              </i>
            </BaseText>
            <BaseInput
              class="flex flex-row justify-between items-center gap-1 xl:gap-2"
              title="Výkonnostné cookie"
              type="checkbox"
              v-model="performance"
              true-value="1"
              false-value="0"
              no-grid />
            <BaseInput
              class="flex flex-row justify-between items-center gap-1 xl:gap-2"
              title="Reklamné cookie"
              type="checkbox"
              v-model="advertisement"
              true-value="1"
              false-value="0"
              no-grid />
          </BaseBox>
          <BaseButton
            @click="(e: Event) => confirm(performance, advertisement)"
            style-name="primary"
            block
            value="Potvrdit výběr" />
        </BaseBox>
      </BaseCollapse>
      <div class="flex flex-row gap-1 xl:gap-2">
        <BaseButton
          @click="(e: Event) => confirm()"
          style-name="primary"
          value="Súhlasím" />
        <BaseButton
          @click="(e: Event) => (optional = (! optional))"
          style-name="secondary"
          value="Nastavenie cookies" />
      </div>
    </BaseModal>
  </div>
</template>
